import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhom() {
  const forWhom = ['Estudiantes universitarias o de postgrado con sobrecarga de exámenes.', 'Profesionales con cargos de alta responsabilidad que sienten que su rendimiento ha bajado.', 'Mujeres que sufren de fatiga por la tarde y necesitan recuperar su energía.', 'Personas que procrastinan porque el esfuerzo mental les resulta doloroso.'];
  const notForWhom = ['Quienes buscan una pastilla "mágica" para estudiar sin dormir.', 'Personas que no están dispuestas a ajustar su alimentación por 48 horas.', 'Quienes buscan diagnósticos o tratamientos para condiciones clínicas médicas.'];
  return <section className="py-24 bg-white" data-id="element-36">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-38">
          {/* Para quién es */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-mint-light/30 p-8 md:p-10 rounded-3xl border border-mint/50" data-id="element-39">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 flex items-center" data-id="element-40">
              <span className="text-green-600 mr-3" data-id="element-41">✓</span> Para quién es esto
            </h3>
            <ul className="space-y-6" data-id="element-42">
              {forWhom.map((item, index) => <li key={index} className="flex items-start" data-id="element-43">
                  <CheckCircle2 className="w-6 h-6 text-green-600 mr-4 flex-shrink-0 mt-0.5" data-id="element-44" />
                  <span className="text-navy/80 leading-relaxed" data-id="element-45">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Para quién NO es */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 p-8 md:p-10 rounded-3xl border border-red-100" data-id="element-46">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 flex items-center" data-id="element-47">
              <span className="text-red-500 mr-3" data-id="element-48">✕</span> Para quién NO es esto
            </h3>
            <ul className="space-y-6" data-id="element-49">
              {notForWhom.map((item, index) => <li key={index} className="flex items-start" data-id="element-50">
                  <XCircle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-51" />
                  <span className="text-navy/80 leading-relaxed" data-id="element-52">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}